import React, { useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import dateFormat from "dateformat";
import { useLocation, useParams } from 'react-router-dom';


import _ from 'lodash';
import cx from "classnames";
import styles from "./styles.module.scss";
import Thumbnail from 'src/components/thumbnail';
import { Asset } from 'src/types/assets';
import Tooltip from "src/components/tooltip";
import { FileService } from 'src/utils/file.service';
import Text from 'src/components/text';
import DOMPurify from 'dompurify';
import { fetchHubspotRecommendedAssets, invalidateHubspotRecommendedAssets } from 'src/redux/actions/integrations/hubspot';

const defaultAssetImg = '/images/defaultIcons/default_asset.jpg'

const AssetCard = ({ asset, editable, onRemove }) => {

  const fileType = useMemo(() => {
    if (asset != null) {
      return FileService.getFileType(asset?.metadata);
    } else {
      return;
    }
  }, [asset]);

  const handleRemove = () => {
    if (onRemove) {
      onRemove(asset);
    }
  }

  const renderAssetSummary = (asset) => {
    if (asset.metadata.pages) {
      return (
        <div className={styles.metrics}>
          <span>{asset.metadata.pages} Pages</span>
        </div>
      );
    } else if (asset.metadata.video_duration) {
      return (
        <div className={styles.metrics}>
          <span>{formartVideoDuration(asset.metadata.video_duration)}</span>
        </div>
      );
    }

    return false;
  }


  const formartVideoDuration = (timeSpent) => {
    let timeSpentValue = `${padNumber(timeSpent, 1)} Seconds`;

    if (timeSpent >= 60) {
      var minutes = Math.round(timeSpent / 60);
      timeSpentValue = `${padNumber(minutes, 1)} Minute${minutes == 1 ? '' : 's'}`;
    }

    return timeSpentValue;
  }

  const padNumber = (number = 0, pad) => {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }
    return padding + number;
  }

  var assetSummary = renderAssetSummary(asset);

  return (
    <a target='_blank' href={`/assets/${asset.id}`} className={cx(styles.card)}>
      <div className={styles.icon}>
        <Thumbnail media={asset?.icon} defaultImage="/images/assets/default_asset.jpg" />
        <div className={styles.fileType}>{fileType}</div>

        {editable &&
          <button className={styles.remove} onClick={handleRemove}>
            <i className="fa-regular fa-circle-xmark"></i>
          </button>
        }
      </div>
      <div className={styles.cardContent}>
        <div className={styles.name}>
          <Text text={DOMPurify.sanitize(asset?.name, { ALLOWED_TAGS: [] })} tooltip={{ placement: "bottom" }} />
        </div>
        <p className={styles.frequentlySharedSubHeading}>
          {assetSummary &&
            <>
              <span className={styles.assetSummary}>{assetSummary}</span>
              <span className={styles.divider}></span>
            </>
          }
          <span>{FileService.formatSize(asset.metadata.content_length)}</span>
        </p>
        {asset.modifiedDate != null &&
          <p className={styles.frequentlySharedSubText}>last update {dateFormat(asset.modifiedDate, 'dd mmm yyyy')}</p>
        }


      </div>
      <i className={cx("paperflite-redirect", styles.arrowIcon)} />
    </a>
  );
}

const RecommendedAssets: React.FC = () => {
  const dispatch: any = useDispatch();
  const assets = useSelector((state: any) => _.get(state, "integrations.hubspot.recommendedAssets.records", []));
  const loading = useSelector((state: any) => _.get(state, "integrations.hubspot.recommendedAssets.loading", false));
  const { opportunityId = "" } = useParams();
  useEffect(() => {
    dispatch(fetchHubspotRecommendedAssets({ dealId: opportunityId })); // Pass the dealId as needed

    return () => {
      dispatch(invalidateHubspotRecommendedAssets());
    }
  }, [opportunityId])

  return (
    <div className={styles.container}>
      {loading && _.size(assets) === 0 &&
        <div>Loading...</div>}
      {_.size(assets) > 0 && (
        <div>
          <div className={styles.assets}>
            {_.map(assets, (asset: any) => (
              <AssetCard asset={asset as Asset} editable={false} onRemove={() => { }} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}


export default RecommendedAssets;